/* eslint-disable no-shadow */

export enum FormStatus {
	pending = 'pending',
	contacted = 'contacted',
	inValidation = 'inValidation',
	approved = 'approved',
	uploadReceipt = 'uploadReceipt',
	scheduled = 'scheduled',
	completed = 'completed',
	expired = 'expired',
	rejected = 'rejected',
	rejectedKyc = 'rejectedKyc',
	canceled = 'canceled',
}
export const FormStatusValues: {
	[key in FormStatus]: {
		title: string;
		color: string;
		tooltip: string;
		order: number;
	};
} = {
	[FormStatus.pending]: {
		title: 'En espera',
		color: 'primary_200',
		tooltip: 'Solicitud en proceso con el vendedor',
		order: 1,
	},
	[FormStatus.contacted]: {
		title: 'Contactado',
		color: 'primary_200',
		tooltip: 'Solicitud contactada',
		order: 2,
	},
	[FormStatus.inValidation]: {
		title: 'Validación',
		color: 'yellow_100',
		tooltip: 'Solicitud pendiente de validación de crédito',
		order: 3,
	},
	[FormStatus.approved]: {
		title: 'Aprobada',
		color: 'green_300',
		tooltip: 'Solicitud aprobada para crédito',
		order: 4,
	},
	[FormStatus.rejected]: {
		title: 'Rechazada',
		color: 'red_300',
		tooltip: 'Solicitud rechazada para crédito',
		order: 4,
	},
	[FormStatus.rejectedKyc]: {
		title: 'Rechazada KYC',
		color: 'red_300',
		tooltip: 'Solicitud rechazada en validación de identidad/KYC',
		order: 4,
	},
	[FormStatus.scheduled]: {
		title: 'Agendada',
		color: 'primary_400',
		tooltip: 'Solicitud agendada para entrega',
		order: 5,
	},
	[FormStatus.uploadReceipt]: {
		title: 'Apartado',
		color: 'primary_400',
		tooltip: 'Solicitud con un vehículo apartado',
		order: 6,
	},
	[FormStatus.completed]: {
		title: 'Completada',
		color: 'secondary_500',
		tooltip: 'Solicitud completada con un crédito',
		order: 7,
	},
	[FormStatus.expired]: {
		title: 'Caducadas',
		color: 'neutral_600',
		tooltip: 'Solicitud expirada por tiempo de inactividad',
		order: 4,
	},
	[FormStatus.canceled]: {
		title: 'Cancelada',
		color: 'neutral_900',
		tooltip: 'Solicitud cancelada por peticion del ozoner',
		order: 4,
	},
};

export enum PartnershipsEnum {
	Uber = 'Uber',
	Didi = 'Didi',
	SinAlianza = 'Sin Alianza',
	BodegaAurrera = 'Bodega Aurrera',
	Walmart = 'Walmart',
}

export enum SalesRankEnum {
	elite = 'elite',
	platinum = 'platinum',
	gold = 'gold',
	silver = 'silver',
	bronze = 'bronze',
	wood = 'wood',
}

export const salesRankValues: {
	[key in SalesRankEnum]: {
		title: string;
		color: string;
		tooltip: string;
	};
} = {
	[SalesRankEnum.elite]: {
		title: 'Elite',
		color: 'elite_color',
		tooltip:
			'En esta segmentacion estan los ozoners que cargaron por su cuenta el ine, selfie y al menos un comprobante de ingresos con buro +650',
	},
	[SalesRankEnum.platinum]: {
		title: 'Platino',
		color: 'platinum_color',
		tooltip:
			'En esta segmentacion estan los ozoners que cargaron por su cuenta el ine, selfie  que son repartidores',
	},
	[SalesRankEnum.gold]: {
		title: 'Oro',
		color: 'gold_color',
		tooltip:
			'En esta segmentacion estan los ozoners que cargaron por su cuenta el ine, selfie y al menos un comprobante de ingresos',
	},
	[SalesRankEnum.silver]: {
		title: 'Plata',
		color: 'silver_color',
		tooltip:
			'En esta segmentacion estan los ozoners que cargaron por su cuenta el ine, selfie y selfie',
	},
	[SalesRankEnum.bronze]: {
		title: 'Bronce',
		color: 'bronze_color',
		tooltip:
			'En esta segmentacion estan los ozoners que cargaron por su cuenta el ine frontal y posterior',
	},
	[SalesRankEnum.wood]: {
		title: 'Madera',
		color: 'wood_color',
		tooltip:
			'En esta segmentacion estan los ozoners que no cargaron por su cuenta ni el ine ni la selfie',
	},
};

export enum RejectedReason {
	FicoScore = 'FicoScore',
	FicoScoreReasons = 'FicoScoreReasons',
	LoanOfferNoValidTier = 'LoanOfferNoValidTier',
	LoanOfferNoViableOffers = 'LoanOfferNoViableOffers',
	LessThanThreeMonthsEmployed = 'LessThanThreeMonthsEmployed',
	DeliveryPersonUsingOthersAccount = 'DeliveryPersonUsingOthersAccount',
	InformationInconsistencies = 'InformationInconsistencies',
	RejectionScore = 'RejectionScore',
	PaymentCapacity = 'PaymentCapacity',
	Truora = 'Truora',
	Fraud = 'Fraud',
	Zoning = 'Zoning',
	Seon = 'Seon',
	PreviousRecovery = 'PreviousRecovery',
	Unemployment = 'Unemployment',
	Address = 'Address',
	DocumentsFromOtherPeople = 'DocumentsFromOtherPeople',
	Age = 'Age',
	Occupation = 'Occupation',
	OzonersTypeD = 'OzonersTypeD',
	TemporaryResidentForeigners = 'TemporaryResidentForeigners',
	ForgedDocuments = 'ForgedDocuments',
	Trully = 'Trully',
	LowIncome = 'LowIncome',
	IdentityValidation = 'IdentityValidation',
}
export const RejectedReasonValues = {
	[RejectedReason.FicoScore]: 'FICO Score bajo',
	[RejectedReason.FicoScoreReasons]: 'Razones FICO Score',
	[RejectedReason.LoanOfferNoValidTier]: 'Tier del usuario inválido',
	[RejectedReason.LoanOfferNoViableOffers]: 'Sin preoferta u ofertas viables',
	[RejectedReason.PaymentCapacity]: 'Capacidad de pago',
	[RejectedReason.Unemployment]: 'Desempleo',
	[RejectedReason.Address]: 'Dirección erronea',
	[RejectedReason.DocumentsFromOtherPeople]: 'Documentos de otra persona',
	[RejectedReason.ForgedDocuments]: 'Documentos falsificados',
	[RejectedReason.Age]: 'Edad',
	[RejectedReason.TemporaryResidentForeigners]:
		'Extranjeros con residencia temporal',
	[RejectedReason.Fraud]: 'Fraude',
	[RejectedReason.InformationInconsistencies]:
		'Inconsistencias en la información',
	[RejectedReason.Occupation]: 'Ocupación',
	[RejectedReason.OzonersTypeD]: 'Ozoner tipo D',
	[RejectedReason.PreviousRecovery]: 'Recuperación previa',
	[RejectedReason.RejectionScore]: 'Score Ozon',
	[RejectedReason.Seon]: 'Seon',
	[RejectedReason.LessThanThreeMonthsEmployed]:
		'Tiene menos de 3 meses en el empleo',
	[RejectedReason.DeliveryPersonUsingOthersAccount]:
		'Trabaja desde la cuenta de otra persona',
	[RejectedReason.Trully]: 'Trully',
	[RejectedReason.Truora]: 'Truora',
	[RejectedReason.Zoning]: 'Zonificación',
	[RejectedReason.LowIncome]: 'Ingresos Bajos',
	[RejectedReason.IdentityValidation]: 'Validación de identidad',
};

export const DEPRECATED_REJECTED_REASONS: RejectedReason[] = [
	RejectedReason.Truora,
	RejectedReason.Seon,
	RejectedReason.Trully,
	RejectedReason.FicoScore,
	RejectedReason.FicoScoreReasons,
	RejectedReason.RejectionScore,
];

export const AUTO_REJECTED_REASONS: RejectedReason[] = [
	RejectedReason.LowIncome,
	RejectedReason.Zoning,
	RejectedReason.Age,
	RejectedReason.LoanOfferNoValidTier,
	RejectedReason.LoanOfferNoViableOffers,
];

export enum DevolutionReason {
	incompleteData = 'incompleteData',
	incompleteDocuments = 'incompleteDocuments',
	expiredDocuments = 'expiredDocuments',
}

export const DevolutionReasonValues = {
	[DevolutionReason.incompleteData]: 'Informacion incompleta',
	[DevolutionReason.incompleteDocuments]: 'Documentos incompletos',
	[DevolutionReason.expiredDocuments]: 'Documentos fuera de los 3 meses',
};

export enum CanceledReason {
	Profession = 'Profession',
	Zoning = 'Zoning',
	UnverifiableIncome = 'UnverifiableIncome',
	LessThanThreeMonthsEmployed = 'LessThanThreeMonthsEmployed',
	NoResponse = 'NoResponse',
	LossOfInterest = 'LossOfInterest',
}

export const CanceledReasonValues = {
	[CanceledReason.Profession]: 'Por profesión',
	[CanceledReason.Zoning]: 'Por zonificación',
	[CanceledReason.UnverifiableIncome]: 'Por ingresos no verificables',
	[CanceledReason.LessThanThreeMonthsEmployed]: 'Menos de 3 meses en el empleo',
	[CanceledReason.NoResponse]: 'Sin respuesta',
	[CanceledReason.LossOfInterest]: 'Perdida de interés',
};

export enum ContactMethodsEnum {
	email = 'email',
	whatsApp = 'whatsApp',
	call = 'call',
	inSite = 'inSite',
}
export const ContactMethodsValues = {
	[ContactMethodsEnum.email]: 'Email',
	[ContactMethodsEnum.whatsApp]: 'Whatsapp',
	[ContactMethodsEnum.call]: 'Llamada',
	[ContactMethodsEnum.inSite]: 'Presencial',
};

export enum LoanSegmentationEnum {
	ClientesGenerales = 'Clientes generales',
	Walmart = 'Walmart',
	CreditLinePayjoy = 'CreditLinePayjoy',
}

export enum CollectionSegmentationEnum {
	GeneralClients = 'Clientes generales',
	NewPurchases = 'Nuevas Compras',
	WO2023 = 'WO 2023',
	Restructuring = 'Reestructuracion',
	Restructured = 'Reestructurado',
	Clients15Interest = 'Clientes 15 intereses',
	Clients30Interest = 'Clientes 30 Intereses',
}

export enum FinancialFormTypeEnum {
	fullPayment = 'FullPaymentFinancialForm',
	loan = 'LoanFinancialForm',
	creditLine = 'CreditLineFinancialForm',
}

export enum DownPaymentStatusEnum {
	noLink = 'no_link',
	pending = 'pending',
	paid = 'paid',
}

export const DownPaymentStatusValues: {
	[key in DownPaymentStatusEnum]: { title: string; color: string };
} = {
	[DownPaymentStatusEnum.noLink]: {
		title: 'Sin link de enganche',
		color: 'red_300',
	},
	[DownPaymentStatusEnum.pending]: {
		title: 'Enganche pendiente',
		color: 'yellow_100',
	},
	[DownPaymentStatusEnum.paid]: {
		title: 'Enganche pagado',
		color: 'green_300',
	},
};

export enum PartnershipPrefixes {
	Walmart = 'W',
}

export enum RevivePreOfferProfileEnum {
	newCirculoRequest = 'newCirculoRequest',
	withoutCirculo = 'withoutCirculo',
	segundasMotos = 'segundasMotos',
}

export const RevivePreOfferProfileValues: {
	[key in RevivePreOfferProfileEnum]: string;
} = {
	[RevivePreOfferProfileEnum.newCirculoRequest]:
		'Correr Círculo de Crédito y calcular el tier',
	[RevivePreOfferProfileEnum.withoutCirculo]:
		'Usuario sin Círculo de Crédito (NB)',
	[RevivePreOfferProfileEnum.segundasMotos]: 'Usuario de segundas motos (B3)',
};

export enum ProfileTierEnum {
	B1 = 'B1',
	B1_CREDIT_LINE = 'B1-CreditLine',
	B2 = 'B2',
	B3 = 'B3',
	NB = 'NB',
	HARD_REJECT = 'HARD_REJECT',
	FRAUD = 'FRAUD',
	A0 = 'A0',
	A = 'A',
	AA = 'AA',
	AAA = 'AAA',
	B = 'B',
	C = 'C',
	E = 'E',
}

export enum LoanPreOfferStatusEnum {
	approved = 'approved',
	rejected = 'rejected',
	expired = 'expired',
}

export enum EconomicActivityEnum {
	empleado = 'empleado',
	repartidor = 'repartidor',
	comerciante = 'comerciante',
	conductor = 'conductor',
	conductorRepartidor = 'conductorRepartidor',
	ayudanteGeneral = 'ayudanteGeneral',
	seguridad = 'seguridad',
	independiente = 'independiente',
	estudiante = 'estudiante',
	policia = 'policia',
	servidorPublico = 'servidorPublico',
	enfermero = 'enfermero',
	mecanico = 'mecanico',
	otro = 'otro',
}

export enum EducationalLevelEnum {
	primary = 'Primaria',
	secondary = 'Secundaria',
	HighSchool = 'Preparatoria',
	AssociateDegree = 'Tecnicatura',
	BachelorDegree = 'Licenciatura',
	MasterDegree = 'Maestria',
}

export enum CivilStatusEnum {
	single = 'Solter@',
	married = 'Casad@',
	Cohabitation = 'Union Libre',
	widower = 'Viud@',
}

export enum LivesWithEnum {
	alone = 'Solo',
	Spouse = 'Esposo (a)',
	friends = 'Amigos',
	parents = 'Padres',
	couple = 'Pareja Estable',
	Siblings = 'Hermanos',
	children = 'Hijos',
}

export enum VehiclePurposeEnum {
	personal = 'personal',
	comercial = 'comercial',
}

export const VehiclePurposeValues: {
	[key in VehiclePurposeEnum]: string;
} = {
	[VehiclePurposeEnum.personal]: 'Uso personal',
	[VehiclePurposeEnum.comercial]: 'Uso comercial',
};

export const financialFormFields = {
	fullAddress: 'dirección del ozoner',
	loanDuration: 'semanas de credito',
	downPayment: 'pago por adelantado',
	rejectedReason: 'motivo de rechazo',
	canceledReason: 'motivo de cancelación',
	devolutionReason: 'motivo de devolución',
	partnership: 'alianza',
	collectionSegmentation: 'segmentacion de cobranza',
	collectionResponsible: 'responsale de cobranza',
	loanSegmentation: 'segmentacion de credito',
	discountId: 'descuento',
	salesRank: 'segmentacion',
	appointment: 'cita de entrega',
	contactMethod: 'metodo de contacto',
	isDataVerified: 'verificacion de cobranza',
	sellResponsible: 'vendedor asignado',
	vehiclePurpose: 'uso de la moto',
	phone: 'telefono',
	dependantsCount: 'dependientes',
	civilStatus: 'estado civil',
	educationalLevel: 'nivel de educacion',
	livesWith: 'vive con',
	personalReferences: 'referencias personales',
	monthlyIncome: 'ingreso mensual',
	monthlyOutcome: 'egreso mensual',
	companyName: 'empresa',
	economicActivity: 'actividad economico',
	workInDigitalPlatforms: 'trabaja en plataformas digitales',
	assets: 'activos',
	createdAt: 'Fecha de creación',
	updatedAt: 'Fecha de actualización',
	termsOfServiceAcceptance: 'termios de servicio',
	privacyPolicyAcceptance: 'politica de privacidad',
	utm: 'UTM',
};
